
import DriverRefresh from "../../../assets/outline/DriverRefresh.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DriverRefreshIcon({ className, dataTestid = "DriverRefreshIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DriverRefresh data-testid={dataTestid} className={classes} {...rest} />
  );
}
